export const QUERY_OPTIONS = {
    staleTime: 1000 * 60 * 5,       // 5 minutes before refetch
    cacheTime: 1000 * 60 * 10,      // 10 minutes before garbage collection
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    refetchOnMount: true,
};



export const createQueryKeys = (resource) => ({
    all: [resource],
    lists: (params) => (params ? [resource, "list", params] : [resource, "list"]),
    item: (id) => (id ? [resource, "item", id] : [resource, "item"]),
});


export const QUERY_KEYS = {
    users: createQueryKeys("users"),
    leads: createQueryKeys("leads"),
    coupons: createQueryKeys("coupons"),
    coupon: createQueryKeys("coupon"),
    couponUsageHistory: createQueryKeys("coupon-usage-history"),
    paymentPlans: createQueryKeys("payment-plans"),
    affiliates: createQueryKeys("affiliates"),
    zapier: createQueryKeys("zapier"),
    leadsImported: createQueryKeys("leads-imported"),
    leadSourceOptions: createQueryKeys("lead-source-options"),
    leadsNotSent: createQueryKeys("leads-not-sent"),
    destinations: createQueryKeys("destinations"),
    scrappingErrors: createQueryKeys("scrapping-errors"),
    emailLogs: createQueryKeys("email-logs"),
    paymentHistory: createQueryKeys("payment-history"),
    paymentMonthWise: createQueryKeys("payment-monthwise"),
    cancelledSubscriptions: createQueryKeys("cancelled-subscriptions"),
    lowActivityUsers: createQueryKeys("low-activity-users"),
    leadSources: createQueryKeys("lead-sources"),
    leadSourceOptions: createQueryKeys("lead-source-options"),
    leadSource: createQueryKeys("lead-source"),
    alerts: createQueryKeys("alerts"),
    timezones: createQueryKeys("timezones"),
    tripleseatLocations: createQueryKeys("tripleseat-locations"),
    mailChimpCampaigns: createQueryKeys("mailchimp-campaigns"),
    weblink: createQueryKeys("weblink"),
    conversate: createQueryKeys("conversate"),
    leadsImportedUser: createQueryKeys("leads-imported-user"),
    leadsImportedViaForm: createQueryKeys("leads-imported-via-form"),
    hotLeads: createQueryKeys("hot-leads"),
    leadsSent: createQueryKeys("leads-sent"),
    notifications: createQueryKeys("notifications"),
    autoresponseSent: createQueryKeys("autoresponse-sent"),
    activityLog: createQueryKeys("activity-log"),
    newLeadAlert: createQueryKeys("new-lead-alert"),
    autoresponders: createQueryKeys("autoresponders"),
    invoices: createQueryKeys("invoices"),
    staticResidentialIps: createQueryKeys("staticResidentialIps"),
    staticResidentialIpsAssignableUsers: createQueryKeys("staticResidentialIpsAssignableUsers"),
};
